import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=b71d1aa2&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"
import style0 from "./Offer.vue?vue&type=style&index=0&id=b71d1aa2&prod&scoped=true&lang=css"
import style1 from "./Offer.vue?vue&type=style&index=1&id=b71d1aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71d1aa2",
  null
  
)

export default component.exports